// 导入必要的依赖
import { LMap, LTileLayer, LMarker, LPopup, LControlScale } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import '@/utils/chinaProvider' // 导入天地图插件

// 解决Leaflet默认图标问题
import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
  name: 'TianDiTuMap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LControlScale
  },
  data() {
    // 从URL获取地图类型
    const urlType = this.$route && this.$route.query.type;
    const validTypes = ['normal', 'satellite', 'terrain'];
    const initialMapType = validTypes.includes(urlType) ? urlType : 'normal';
    
    return {
      // 地图中心点
      center: [30.4655, 121.0110],
      // 缩放级别
      zoom: 12,
      // 标记位置
      markerLatLng: [30.4655, 121.0110],
      // 当前地图类型
      currentMapType: initialMapType,
      // 地图类型选项
      mapTypes: [
        { label: '矢量地图', value: 'normal' },
        { label: '卫星影像', value: 'satellite' },
        { label: '地形图', value: 'terrain' }
      ],
      // 天地图key
      tiandituKey: '038937b9b91fd28203af58e3dd9b1396',
      // 图层配置
      layers: [],
      // 地图配置选项
      mapOptions: {
        zoomControl: false, // 禁用默认缩放控件，用ElementUI的slider代替
        attributionControl: true
      },
      // 标记信息
      markerInfo: {
        title: '北京市中心',
        description: '中国首都，政治、文化、国际交往中心'
      },
      // 对话框可见性
      dialogVisible: false,
      // 抽屉可见性
      drawerVisible: false,
      // 搜索关键词
      searchKeyword: '',
      // 是否显示标注
      showLabels: true,
      // Leaflet地图实例
      map: null,
      // 鼠标位置
      mousePosition: {
        lat: 0,
        lng: 0
      }
    }
  },
  computed: {
    // 格式化经度显示
    formatLongitude() {
      return this.convertToDMS(this.mousePosition.lng, 'lng');
    },
    // 格式化纬度显示
    formatLatitude() {
      return this.convertToDMS(this.mousePosition.lat, 'lat');
    }
  },
  watch: {
    // 监听showLabels变化，动态控制标注图层
    showLabels(newVal) {
      this.toggleLabels(newVal);
    },
    // 监听路由变化
    '$route.query.type'(newType) {
      if (newType && ['normal', 'satellite', 'terrain'].includes(newType)) {
        this.changeMapType(newType);
      }
    }
  },
  created() {
    // 初始化图层
    this.initLayers()
  },
  methods: {
    // 初始化图层
    initLayers() {
      this.updateLayers(this.currentMapType)
    },
    // 更新图层
    updateLayers(mapType) {
      // 清空当前图层
      this.layers = []
      
      // 配置图层
      switch(mapType) {
        case 'normal':
          // 矢量图层
          this.layers.push({
            name: 'TianDiTu.Normal.Map',
            url: `https://t{s}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk=${this.tiandituKey}`,
            attribution: '&copy; 天地图',
            subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
            layerType: 'base',
            visible: true,
            options: {
              maxZoom: 18,
              minZoom: 5
            }
          })
          // 注记图层
          if (this.showLabels) {
            this.layers.push({
              name: 'TianDiTu.Normal.Annotion',
              url: `https://t{s}.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=${this.tiandituKey}`,
              attribution: '&copy; 天地图',
              subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
              layerType: 'overlay',
              visible: true,
              options: {
                maxZoom: 18,
                minZoom: 5
              }
            })
          }
          break
        case 'satellite':
          // 卫星影像
          this.layers.push({
            name: 'TianDiTu.Satellite.Map',
            url: `https://t{s}.tianditu.gov.cn/DataServer?T=img_w&X={x}&Y={y}&L={z}&tk=${this.tiandituKey}`,
            attribution: '&copy; 天地图',
            subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
            layerType: 'base',
            visible: true,
            options: {
              maxZoom: 18,
              minZoom: 5
            }
          })
          // 卫星影像注记
          if (this.showLabels) {
            this.layers.push({
              name: 'TianDiTu.Satellite.Annotion',
              url: `https://t{s}.tianditu.gov.cn/DataServer?T=cia_w&X={x}&Y={y}&L={z}&tk=${this.tiandituKey}`,
              attribution: '&copy; 天地图',
              subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
              layerType: 'overlay',
              visible: true,
              options: {
                maxZoom: 18,
                minZoom: 5
              }
            })
          }
          break
        case 'terrain':
          // 地形图
          this.layers.push({
            name: 'TianDiTu.Terrain.Map',
            url: `https://t{s}.tianditu.gov.cn/DataServer?T=ter_w&X={x}&Y={y}&L={z}&tk=${this.tiandituKey}`,
            attribution: '&copy; 天地图',
            subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
            layerType: 'base',
            visible: true,
            options: {
              maxZoom: 18,
              minZoom: 5
            }
          })
          // 地形图注记
          if (this.showLabels) {
            this.layers.push({
              name: 'TianDiTu.Terrain.Annotion',
              url: `https://t{s}.tianditu.gov.cn/DataServer?T=cta_w&X={x}&Y={y}&L={z}&tk=${this.tiandituKey}`,
              attribution: '&copy; 天地图',
              subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
              layerType: 'overlay',
              visible: true,
              options: {
                maxZoom: 18,
                minZoom: 5
              }
            })
          }
          break
      }
    },
    // 切换地图类型
    changeMapType(type) {
      this.currentMapType = type
      this.updateLayers(type)
    },
    // 显示标记详情
    showMarkerDetails() {
      this.dialogVisible = true
    },
    // 搜索位置
    searchLocation() {
      if (!this.searchKeyword.trim()) {
        this.$message.warning('请输入搜索关键词')
        return
      }
      
      // 在实际应用中，这里应该调用天地图或其他地理编码服务
      // 这里只是模拟
      this.$message.success(`正在搜索: ${this.searchKeyword}`)
      
      // 模拟搜索结果
      setTimeout(() => {
        // 随机生成一个北京周围的位置
        const randomLat = 39.908 + (Math.random() - 0.5) * 0.1
        const randomLng = 116.397 + (Math.random() - 0.5) * 0.1
        
        this.markerLatLng = [randomLat, randomLng]
        this.markerInfo = {
          title: this.searchKeyword,
          description: `这是搜索"${this.searchKeyword}"的结果位置`
        }
        
        // 更新地图中心
        this.center = [randomLat, randomLng]
        
        this.$message.success('搜索完成！')
        this.drawerVisible = false
      }, 1000)
    },
    // 切换标注
    toggleLabels(show) {
      this.updateLayers(this.currentMapType)
    },
    
    // 地图准备完成
    onMapReady(mapObject) {
      this.map = mapObject;
      
      // 添加鼠标移动事件监听
      this.map.on('mousemove', this.onMouseMove);
    },
    
    // 鼠标移动事件处理
    onMouseMove(e) {
      this.mousePosition = {
        lat: e.latlng.lat,
        lng: e.latlng.lng
      };
    },
    
    // 更新中心点
    centerUpdated(center) {
      this.center = center;
    },
    
    // 更新缩放级别
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    
    // 将十进制经纬度转换为度分秒格式
    convertToDMS(decimal, type) {
      if (decimal === 0) {
        return type === 'lat' ? '-- ° -- ′ -- ″ N' : '-- ° -- ′ -- ″ E';
      }
      
      const absolute = Math.abs(decimal);
      const degrees = Math.floor(absolute);
      const minutesNotTruncated = (absolute - degrees) * 60;
      const minutes = Math.floor(minutesNotTruncated);
      const seconds = Math.floor((minutesNotTruncated - minutes) * 60);
      
      const direction = type === 'lat' 
        ? (decimal >= 0 ? 'N' : 'S') 
        : (decimal >= 0 ? 'E' : 'W');
        
      return `${degrees}°${minutes < 10 ? '0' : ''}${minutes}′${seconds < 10 ? '0' : ''}${seconds}″ ${direction}`;
    }
  }
} 